type Translate = (key: string, values?: any) => any;

function translateToString(translate: Translate, key: string, values?: any): string {
	return String(translate(key, values));
}

export function resolveTranslatedMessage(translate: Translate, key: string): string | null {
	const translatedMessage = translateToString(translate, key);

	return translatedMessage !== key ? translatedMessage : null;
}

export function resolveFirstTranslatedMessage(translate: Translate, keys: string[]): string | null {
	for (const key of keys) {
		const translatedMessage = resolveTranslatedMessage(translate, key);

		if (translatedMessage) {
			return translatedMessage;
		}
	}

	return null;
}

export function extractBadUsageReason(value: string): string | null {
	const matchBadUsage = value.trim().match(/^bad\.usage\((.+)\)$/);

	return matchBadUsage ? matchBadUsage[1].trim() : null;
}

export function translateBadUsage(translate: Translate, value: string): string | null {
	const trimmedValue = value.trim();
	const reason = extractBadUsageReason(trimmedValue);

	if (reason) {
		return resolveTranslatedMessage(translate, `error.badUsage.${reason}`)
			?? translateToString(translate, "error.badUsage.generic");
	}

	return resolveFirstTranslatedMessage(translate, [
		`error.badUsage.${trimmedValue}`,
		trimmedValue
	]);
}